<vb-title [title]="videoInfo.title"></vb-title>

<div class="row system-login-shell" [ngStyle]="{ 'background-image': 'url(' + videoInfo.thumbnailUri + ')' }">

	<div class="col-12 col-sm-8 col-md-5 col-lg-4 system-login">
		<form #videoPasswordForm="ngForm" class="system-form" name="videoPasswordForm" (submit)="submit()">
			<h1>{{ videoInfo.title }}</h1>

			<div class="description" *ngIf="videoInfo.description" [innerHTML]="videoInfo.description | safeHtml">
			</div>

			<div class="system-msg error-msg" [hidden]="!showPasswordError">
					<span class="glyphicons remove_2"></span>
					{{ 'IncorrectPassword' | translate }}
			</div>

			<div class="input-fields">
				<div class="password">
					<input type="password" class="form-control input-with-icon" name="password" [placeholder]="'Password' | translate" required [(ngModel)]="password" (ngModelChange)="onPasswordInputChange()" disable-password-autocomplete>

					<span class="glyphicons lock"></span>
				</div>
			</div>

			<div class="group">
				<button class="btn-icon-right btn-lg float-right" type="submit" [disabled]="videoPasswordForm.invalid" vbBtnPrimary>
					{{ 'Ok' | translate }}
				</button>
			</div>

			<div class="group registered-user">
				{{ 'RegisteredUser' | translate }}
				<a (click)="loginRedirect()">{{ 'SignInHere' | translate }}</a>
			</div>
		</form>
	</div>
</div>
